import { ServicesData } from "assets/data/ServicesData";
import { NavLink } from "react-router-dom";
import SectionHeading from "components/common/SectionHeading";
import ScrollReveal from "components/common/ScrollReveal";

const OurServices = () => {
    return (
        <section>
            <div className="container">
                <SectionHeading
                    eyebrow="Our Services"
                    title="What we do"
                    description="Comprehensive IT solutions designed to modernize your infrastructure, secure your data, and accelerate business growth."
                />
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                    {ServicesData.map((service, index) => (
                        <ScrollReveal
                            key={service.title}
                            variant="up"
                            delay={index * 100}
                        >
                            <div className="service-card group">
                                <div className="service-card-image">
                                    <img
                                        src={service.Image}
                                        alt={service.title}
                                    />
                                </div>
                                <h3 className="text-lg font-bold text-black mb-3 group-hover:text-primary duration-300">
                                    {service.title}
                                </h3>
                                <p className="text-sm text-secondary/70 leading-relaxed mb-6 flex-grow">
                                    {service.description}
                                </p>
                                <NavLink
                                    className="inline-flex items-center gap-1 text-primary font-semibold text-sm group-hover:gap-2 duration-300 mt-auto"
                                    to={service.url}
                                >
                                    Learn More
                                    <span aria-hidden="true">&rarr;</span>
                                </NavLink>
                            </div>
                        </ScrollReveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurServices;
